import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class DragCtxService {

  readonly draggingSubject = new BehaviorSubject<boolean>(false);
  readonly droppedEv = new EventEmitter<CdkDragDrop<any>>(null);
  readonly dragPositionSubject = new BehaviorSubject<{ x: number, y: number }>(null);

  constructor() { }

}
